import { t } from "@lingui/macro";
import { I18n } from "@lingui/core";

import { FieldName } from "..";

export default (i18n: I18n) => ({
  iban: {
    name: FieldName.iban,
    label: "IBAN",
    placeholder: `${i18n._(
      t({
        id: "placeholder.example",
        message: "e.g.",
      })
    )} IE29 AIBK 9311 5212 3456 78`,
    instructions: i18n._(
      t({
        id: "fields-config.iban.instructions",
        message: `International Bank Account Number`,
      })
    ),
  },
  local: [
    {
      name: FieldName.branchCode,
      label: "Branch code",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 10-20-30`,
      instructions: i18n._(
        t({
          id: "fields-config.branch-code.instructions",
          message: "Branch code",
        })
      ),
    },
    {
      name: FieldName.accountNumber,
      label: "Account number",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 12345678`,
      instructions: i18n._(
        t({
          id: "fields-config.account-number.instructions",
          message: "Account number",
        })
      ),
    },
  ],
  primaryBankDetailsFields: [FieldName.iban],
  secondaryBankDetailsField: [FieldName.branchCode, FieldName.accountNumber],
});
